import React from 'react';
import {connect} from 'react-redux';
import {Alert} from 'react-bootstrap';
import {clearCirclesData} from "./state/tableCirclesState";
import {clearSquaresData} from "./state/tableSquaresState";

class ClearButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ask: false
        };

        this.askUser = () => {
            this.setState({ask: true})
        };

        this.handleDismiss = () => {
            this.setState({ask: false})
        };

        this.clearTable = () => {
            if (this.props.active_Table === 'SQUARES') {
                this.props.clearSquaresData(this.props.squareStartingData);
            }
            else if (this.props.active_Table === 'CIRCLES') {
                this.props.clearCirclesData(this.props.circlesStartingData)
            }
            this.setState({ask: false})
        }
    }

    render() {
        let content = '';
        if (this.state.ask) {
            content =
                <div id="alertOnClear">
                    <Alert bsStyle="warning">
                        <p style={{'margin': '0 0 1.4rem 0', 'color': '#ffffff', 'fontFamily': 'Robota, sans-serif'}}>Czy na pewno
                            chcesz wyczyścić matę?</p>
                        <div className="d-flex flex-row justify-content-between">
                            <button id="confirmClear" className="btn" onClick={this.clearTable}>Tak, wyczyść matę
                            </button>
                            <button id="rejectClear" className="btn" onClick={this.handleDismiss}>Nie</button>
                        </div>
                    </Alert>
                </div>
        }

        return (
            <div>
                {content}
                <button id="btnMataClear" onClick={this.askUser}>
                    Wyczyść matę
                </button>
            </div>
        )
    }
}

export default connect(
    state => ({
        active_Table: state.activeTable,
        circlesStartingData: state.circlesState,
        squareStartingData: state.squaresState
    }),
    {clearCirclesData, clearSquaresData}
)(ClearButton)


// WEBPACK FOOTER //
// ./src/ClearButton.js